import * as R from 'ramda'

import isNilOrEmpty from './isNilOrEmpty'

export default R.complement(isNilOrEmpty)
